import {Injectable, Injector} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {Location} from '@angular/common';
import {StudentEntity} from "../../model/StudentEntity";
import {Subscription, throwError} from "rxjs";
import {ContextDto} from "../../dto/ContextDto";
import {CorporationEntity} from "../../model/CorporationEntity";
import {SubscriptionEntity} from "../../model/SubscriptionEntity";
import {NotificationEntity} from "../../model/NotificationEntity";
import {Device} from '@ionic-native/device/ngx';
import {Platform} from "@ionic/angular";
import {TranslationEntity} from "../../model/TranslationEntity";
import {ManagerEntity} from "../../model/ManagerEntity";
import {LogEntity} from "../../model/LogEntity";
import * as moment from 'moment-timezone';
import {CorpStyleEntity} from "../../model/CorpStyleEntity";
import {catchError} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {TutorEntity} from "../../model/TutorEntity";
import {ProfessorEntity} from "../../model/ProfessorEntity";
import {ManagerPermissionEntity} from "../../model/ManagerPermissionEntity";

@Injectable({
  providedIn: 'root'
})
export class Shared {

  //MAGNAMENT_URL = "http://localhost:8102";
  //MAGNAMENT_URL = "http://192.168.0.229:8102";
  //MAGNAMENT_URL = "http://192.168.41.14:8102";
  //MAGNAMENT_URL = "http://192.168.1.11:8102"
  MAGNAMENT_URL = "https://magnament-back.mediplus.es"

  CHAT_URL = "https://chat-back.mediplus.es"
  //CHAT_URL = "http://192.168.40.206:8103";
  CORP_ALIAS = "MD";
  CORP_ID = 1;

  public CURRENT_CORP: CorporationEntity;
  public CURRENT_USER: StudentEntity;
  public CURRENT_TYPE: string;
  public CURRENT_MANAGER: ManagerEntity;
  public CURRENT_TUTOR: TutorEntity;
  public CURRENT_PROFESSOR: ProfessorEntity;
  public CURRENT_SUBSCRIPTION: SubscriptionEntity;
  public CURRENT_SUBS_NUMBER: number = 0;
  public SUBSCRIPTIONS: SubscriptionEntity[];
  public TRANSLATIONS: TranslationEntity[];
  public CURRENT_LANGUAGE = 'ES';
  public CURRENT_IP: string;
  public CURRENT_LOCATION: any;
  public SERVER_TIMEZONE = 'Etc/GMT';
  public DARKMODE: boolean = false;
  public STYLE: CorpStyleEntity;
  public PERMISSIONS: ManagerPermissionEntity[];

  public CORPS: CorporationEntity[];

  public isMenuColapsed = true;

  public NOTIFICATIONS: NotificationEntity[] = [];

  videoPlayer;

  subscriptionMoment: Subscription;
  subscriptionChat: Subscription;
  savedUrL: string = "";

  haveNotifications: boolean = false;

  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: true,
    placeholder: 'Enter text here...',
    fonts: [
      {class: 'arial', name: 'Arial'},
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['indent', 'outdent', 'superscript', 'subscript', 'link', 'unlink', 'insertImage', 'insertVideo', 'strikeThrough', 'fontName'],
    ]
  };

  constructor(private router: Router, private route: ActivatedRoute, private location: Location, private http: HttpClient, private device: Device, private platform: Platform, public toastr: ToastrService) {

    if (this.checkHostInReferrer('localhost')) {
      console.log("Local");
      //Iván
      this.MAGNAMENT_URL = "http://192.168.0.197:8102";
      //this.MAGNAMENT_URL = "http://10.137.135.86:8102";
      //this.MAGNAMENT_URL = "http://172.24.19.86:8102";
    }

    router.events.subscribe((val) => {
      if (this.savedUrL != null && this.savedUrL != undefined && this.savedUrL != "") {
        if (window.location.href != this.savedUrL) {
          this.videoPlayer.pause();
          this.subscriptionMoment.unsubscribe();
          this.subscriptionChat.unsubscribe();
          this.savedUrL = "";
        }
      }
    });

    this.CURRENT_MANAGER = JSON.parse(localStorage.getItem('CURRENT_MANAGER'));
    this.CURRENT_TUTOR = JSON.parse(localStorage.getItem('CURRENT_TUTOR'));
    this.CURRENT_PROFESSOR = JSON.parse(localStorage.getItem('CURRENT_PROFESSOR'));
    this.CURRENT_CORP = JSON.parse(localStorage.getItem('CURRENT_CORP'));

    if (this.CURRENT_CORP != null) {
      this.CORP_ID = this.CURRENT_CORP.id;
      this.CORP_ALIAS = this.CURRENT_CORP.alias;
    }

    if(!this.checkLocation('/singleThread')) {
      if((this.CURRENT_MANAGER == null || this.CURRENT_MANAGER == undefined) && (this.CURRENT_TUTOR == null || this.CURRENT_TUTOR == undefined) && (this.CURRENT_PROFESSOR == null || this.CURRENT_PROFESSOR == undefined)){
        if(window.location.href.indexOf('loginManager')!=-1){
          this.goTo(['/', 'loginManager']);
        }else if(window.location.href.indexOf('loginTutor')!=-1){
          this.goTo(['/', 'loginTutor']);
        }else if(window.location.href.indexOf('loginProfessor')!=-1){
          this.goTo(['/', 'loginProfessor']);
        }else {
          this.goTo(['/', 'login']);
        }
      }else{
        if(this.CURRENT_MANAGER != null){
          this.afterLogin(this.CURRENT_CORP.id, this.CURRENT_MANAGER.id, this.CURRENT_MANAGER.token, "MANAGER", false);
        } else if(this.CURRENT_TUTOR != null){
          this.afterLogin(this.CURRENT_CORP.id, this.CURRENT_TUTOR.id, this.CURRENT_TUTOR.token, "TUTOR", false);
        } else if(this.CURRENT_PROFESSOR != null){
          this.afterLogin(this.CURRENT_CORP.id, this.CURRENT_PROFESSOR.id, this.CURRENT_PROFESSOR.token, "PROFESSOR", false);
        }
      }
    }
  }

  afterLogin(corpId, managerId, token, type, redirectHome: boolean = true) {
    const headers = new HttpHeaders()
      .set('Access-Control-Allow-Origin', '*')
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`);

    this.http.get<ContextDto>(this.MAGNAMENT_URL + '/getContext/' + corpId + '/' + managerId+ '/' + type, {headers}).pipe(catchError((error: HttpErrorResponse) => this.handleError(error))).subscribe((x: ContextDto) => {
      if(type == "MANAGER") {
        console.log(x);
        this.CURRENT_MANAGER = x.manager;
        this.CURRENT_MANAGER.token = token;
        this.CORPS = x.corps;
        this.PERMISSIONS = x.permissions;
      }else if(type == "TUTOR"){
        this.CURRENT_TUTOR = x.tutor;
        this.CURRENT_TUTOR.token = token;
        this.CORPS = [x.corporation];
      }else if(type == "PROFESSOR"){
        this.CURRENT_PROFESSOR = x.professor;
        this.CURRENT_PROFESSOR.token = token;
        this.CORPS = [x.corporation];
      }

      this.CURRENT_TYPE = type;

      this.CURRENT_CORP = x.corporation;

      /*interval(300000).subscribe(val => this.checkNotifications());
      this.checkNotifications();*/

      this.CORP_ID = this.CURRENT_CORP.id;
      this.CORP_ALIAS = this.CURRENT_CORP.alias;

      if (redirectHome) {
        this.goTo(['/']);
      }

      localStorage.removeItem('CURRENT_MANAGER');
      localStorage.removeItem('CURRENT_TUTOR');
      localStorage.removeItem('CURRENT_PROFESSOR');
      localStorage.removeItem('CURRENT_CORP');

      if(this.CURRENT_MANAGER != null) {
        if (!this.CURRENT_MANAGER.corporations.includes(this.CURRENT_CORP.id + "")) {
          localStorage.setItem('CURRENT_MANAGER', JSON.stringify(this.CURRENT_MANAGER));
          this.CURRENT_CORP = this.CORPS.find(y => y.id === this.CURRENT_MANAGER.corpId);
          localStorage.setItem('CURRENT_CORP', JSON.stringify(this.CURRENT_CORP));
          window.location.reload();
        } else {
          localStorage.setItem('CURRENT_MANAGER', JSON.stringify(this.CURRENT_MANAGER));
          localStorage.setItem('CURRENT_CORP', JSON.stringify(this.CURRENT_CORP));
        }
      }else if(this.CURRENT_TUTOR != null) {
        localStorage.setItem('CURRENT_TUTOR', JSON.stringify(this.CURRENT_TUTOR));
        localStorage.setItem('CURRENT_CORP', JSON.stringify(this.CURRENT_CORP));
      }else if(this.CURRENT_PROFESSOR != null) {
        localStorage.setItem('CURRENT_PROFESSOR', JSON.stringify(this.CURRENT_PROFESSOR));
        localStorage.setItem('CURRENT_CORP', JSON.stringify(this.CURRENT_CORP));
      }
    })
    this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
      if (res != null) {
        this.CURRENT_IP = res.ip;
        this.http.get("https://ipapi.co/" + this.CURRENT_IP + "/json")
          .subscribe({
            next: (result: any) => {
              if (result != null) {
                console.log(result);

                this.CURRENT_LOCATION = result;

                moment.locale(this.CURRENT_LOCATION.languages.split(',')[0]);
                moment.tz.setDefault('Etc/GMT');
              }
            },
            error: (err) => {
              console.error('Error obteniendo ubicación', err);

              this.CURRENT_LOCATION = {
                languages: 'es-ES',
                timezone: this.CURRENT_CORP.timezone
              };

              moment.locale('es');
              moment.tz.setDefault(this.CURRENT_CORP.timezone);
            }
          });
      }
    });

    this.getStyle(headers);
  }

  getStyle(headers) {
    return this.http.get<CorpStyleEntity>(this.MAGNAMENT_URL + '/getCorpStyle/' + this.CORP_ID, {headers}).pipe(catchError((error: HttpErrorResponse) => this.handleError(error))).subscribe((x: CorpStyleEntity) => {
      if (x != null) {
        this.STYLE = x;
      }
    });
  }

  async getCorpGroups() {
    while (this.CORPS == null) {
      await this.delay(200);
    }
    if(this.CURRENT_TYPE == 'MANAGER') {
      let output = this.CURRENT_MANAGER.corporations.split(',').map(Number);
      output = output.filter(p => this.CORPS.find(t => t.id == p).corpGroup == this.CURRENT_CORP.corpGroup);
      return output.join(',');
    }else if(this.CURRENT_TYPE == 'TUTOR') {
      return this.CURRENT_CORP.id.toString();
    }else if(this.CURRENT_TYPE == 'PROFESSOR') {
      return this.CURRENT_CORP.id.toString();
    }
  }

  changeThemeMode() {
    this.DARKMODE = !this.DARKMODE;
    if (!this.DARKMODE) {
      this.CURRENT_SUBSCRIPTION.settings.theme = 0
    } else {
      this.CURRENT_SUBSCRIPTION.settings.theme = 1
    }
    document.body.classList.toggle('dark');
  }

  changeLanguage(language) {
    this.CURRENT_LANGUAGE = language;
    this.CURRENT_SUBSCRIPTION.settings.language = language;
    this.http.get<TranslationEntity[]>(this.MAGNAMENT_URL + '/getTranslation/' + language, this.headers()).pipe(catchError((error: HttpErrorResponse) => this.handleError(error))).subscribe(x => {
      if (x != null) {
        this.TRANSLATIONS = x;
      }
    });
  }

  checkNotifications() {
    this.http.get<NotificationEntity[]>(this.MAGNAMENT_URL + '/getNotifications/' + this.CURRENT_SUBSCRIPTION.reference, this.headers()).pipe(catchError((error: HttpErrorResponse) => this.handleError(error))).subscribe((x: NotificationEntity[]) => {
      if (x != null) {
        this.NOTIFICATIONS = x;
        console.log(this.NOTIFICATIONS.find(x => !x.showed));
        if (this.NOTIFICATIONS.find(x => !x.showed) != null) {
          this.haveNotifications = true;
        } else {
          this.haveNotifications = false;
        }
      }
    });
  }

  saveUrl() {
    this.savedUrL = window.location.href;
  }

  headers() {
    let token = "";
    if(this.CURRENT_MANAGER != null){
      token = this.CURRENT_MANAGER.token;
    }else if(this.CURRENT_TUTOR != null){
      token = this.CURRENT_TUTOR.token;
    }else if(this.CURRENT_PROFESSOR != null){
      token = this.CURRENT_PROFESSOR.token;
    }

    let options = {
      headers: new HttpHeaders()
        .set('Access-Control-Allow-Origin', '*')
        .set('Authorization', `Bearer ${token}`)
    };
    return options;
  }

  checkUrl(urlToCheck: string) {
    if (this.router.url.indexOf(urlToCheck) >= 0) return true;
    return false;
  }

  checkHostInLocation(urlToCheck: string) {
    if (window.location.host.indexOf(urlToCheck) >= 0) return true;
    return false;
  }

  checkLocation(urlToCheck: string) {
    if (this.location.path().indexOf(urlToCheck) >= 0) return true;
    return false;
  }

  checkHostInReferrer(urlToCheck: string) {
    if (document.location.hostname.includes(urlToCheck)) {
      return true;
    } else {
      return false;
    }
  }

  handleError(error: HttpErrorResponse) {
    console.log(error);
    if (error.status === 401) {
      this.goTo(['login','logout']);
      return throwError('401');
    } else if (error.status === 403) {
      this.goTo(['login','logout']);
      return throwError('403');
    } else if (error.status === 500) {
      this.toastr.error('Error en el servidor, contacta con informática', 'Error en el servidor');
      return throwError('500');
    } else if (error.status === 400) {
      this.toastr.error('Revisa los parametros introducidos y vuelve a enviarlos, quizás falta un campo o alguno es incorrecto', 'Error en el envío de parámetros');
      return throwError('400');
    } else{
      this.toastr.error('Error, vuelve a intentarlo y si persiste, contacta con informática', 'Error');
      return throwError(error.status);
    }
  }

  handleErrorLogin(error: HttpErrorResponse) {
    if (error.status === 401) {
      return throwError('401');
    } else if (error.status === 403) {
      return throwError('403');
    } else {
      return throwError('400');
    }
  }


  getLastVariableFromUrl(name: string) {
    let toReturn;
    this.route.params.subscribe((params: Params) => {
      toReturn = params[name]
    });
    if (toReturn == null || toReturn == undefined) {
      let array = this.router.url.split('/');
      toReturn = array[(array.length - 1)];
    }
    return toReturn;
  }

  goBack() {
    this.location.back();
  }

  goTo(url) {
    this.router.navigate(url);
  }

  goExternalTo(url) {
    window.open(url, '_system')
  }

  goInternalTo(url) {
    this.router.navigateByUrl(url);
  }

  saveLog(body) {
    if(!this.checkUrl('/singleThread') && (this.CURRENT_MANAGER != null || this.CURRENT_TUTOR != null || this.CURRENT_PROFESSOR != null)) {
      let log: LogEntity = new LogEntity();
      log.corpId = this.CORP_ID;
      if(this.CURRENT_MANAGER != null) {
        log.managerId = this.CURRENT_MANAGER.id;
      }else if(this.CURRENT_TUTOR != null) {
        log.tutorId = this.CURRENT_TUTOR.id;
      }else if(this.CURRENT_PROFESSOR != null) {
        log.professorId = this.CURRENT_PROFESSOR.id;
      }
      log.dateTime = moment().format('yyyy-MM-DDTHH:mm:ss');
      log.ip = this.CURRENT_IP;
      if (this.platform.is('cordova')) {
        log.device = this.device.version;
      } else {
        log.device = window.navigator.userAgent;
      }
      if (body != null) {
        if (body.profileImage != null) {
          body.profileImage = "";
        }
        if (body.front != null) {
          body.front = "";
        }
        log.body = JSON.stringify(body);
      }

      log.url = window.location.href;

      this.http.post(this.MAGNAMENT_URL + '/saveLog', log, this.headers()).subscribe();
    }
  }

  async isPermissionsCharged() {
    while (this.PERMISSIONS == null) {
      await this.delay(200);
    }
  }

  checkIsPermitted(name) {
    this.isPermissionsCharged();
    if (this.PERMISSIONS != null) {
      if (this.PERMISSIONS.filter(x => x.name == name && x.type == 'ADD').length == 0) {
        return false;
      } else {
        return true;
      }
    }
  }

  /**
   * Permisos de la zona de IA.
   *
   * shared.PERMISSIONS son los de manager_permissions, que no es la tabla permissions del catalogo
   * de roles: dar de alta ahi un permiso nuevo no se lo reparte a nadie. Mientras el manager no
   * tenga AI_QUESTIONS en su lista se entiende que ese reparto todavia no se ha hecho y no se
   * esconde nada, porque si no un front desplegado por delante de los datos deja la pantalla
   * muerta y sin ninguna pista de por que. En cuanto AI_QUESTIONS aparece en manager_permissions,
   * este metodo pasa a comportarse igual que checkIsPermitted y los permisos finos mandan.
   */
  checkIsAiPermitted(name) {
    if (this.checkIsPermitted('AI_QUESTIONS') !== true) {
      return true;
    }
    return this.checkIsPermitted(name) === true;
  }

  checkIsExcluded(name) {
    this.isPermissionsCharged();
    if (this.PERMISSIONS != null) {
      if (this.PERMISSIONS.filter(x => x.name == name && x.type == 'EXCLUDE').length == 0) {
        return false;
      } else {
        return true;
      }
    }
  }

  t(word: string) {
    if (this.TRANSLATIONS != null && this.TRANSLATIONS.length > 0) {
      if (this.TRANSLATIONS.find(x => x.word == word) != null) {
        return this.TRANSLATIONS.find(x => x.word == word).translation;
      } else {
        return word;
      }
    } else {
      return word;
    }
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
